import { Link, useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from "moment"
import constant from "../../constant"
import { TripTypeBadge, bookingKm, bookingCost } from "../../components/bookingMeta";
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

import { Rating } from 'react-simple-star-rating'
const OrderDetails = () => {

    const isMobileView = useIsMobile();
    const params = useParams()
    const [bookingDetail, setBookingDetail] = useState()
    const [isPaymentDone, setIsPaymentDone] = useState()
    const [isPayment, setIsPayment] = useState()
    const [mealCost, setMealCost] = useState()
    const [tollTax, setTollTax] = useState()
    const [otherCost, setOtherCost] = useState()
    const [paymentMode, setPaymentMode] = useState()
    const [paymentRef, setPaymentRef] = useState()
    const [image, setImage] = useState()
    useEffect(() => {
        getBookingsHandler();
    }, [])
    const getBookingsHandler = async () => {
        try {
            const response = await services.order.BOOKING_DETAIL(params.id);
            let data = response.data;
            
            data.BookingDetails.sort(function(a, b) {
                    return parseFloat(a.id) - parseFloat(b.id);
                });
           
            setBookingDetail(data)

            if (data?.BookingDetails[0]?.BookingPayment?.BookingPaymentDetails[0]?.paymentStatus =='success') {
                setIsPayment(data?.BookingDetails[0]?.BookingPayment?.BookingPaymentDetails[0]?.amount);
                setIsPaymentDone(data?.BookingDetails[0]?.BookingPayment?.BookingPaymentDetails[0]?.paymentStatus)
            }
            if (data?.BookingDetails[0]?.bookingStatus == 'ended') {
                let index = data?.BookingDetails[0]?.BookingPayment.BookingPaymentDetails.length;
                let obj = data?.BookingDetails[0]?.BookingPayment.BookingPaymentDetails[index - 1].transactionData;

                setMealCost(obj.mealCost)
                setTollTax(obj.tollTax)
                setOtherCost(obj.otherCost)
                setPaymentRef(obj.paymentRef)
                setPaymentMode(obj.paymentMode)
                if(data?.BookingDetails[0]?.amountBreakdown.remainingAmount){
                    let totalAccoupants = bookingDetail.carData.customerCapacity - bookingDetail.sharingAvailable;
                setMealCost(obj.mealCost*totalAccoupants)
                setTollTax(obj.tollTax*totalAccoupants)
                setOtherCost(obj.otherCost*totalAccoupants)
                setPaymentRef(obj.paymentRef)
                setPaymentMode(obj.paymentMode)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const changeStatusHandler = async () => {
        try {
            let data = {
                bookingStatus: 'started',
                bookingId: bookingDetail.id,
                bookingDetailId: bookingDetail.BookingDetails[0].id,
            }
            const response = await services.order.UPDATE_STATUS(data);
            console.log(response)
            getBookingsHandler()
        } catch (error) {
            console.log(error)
        }
    }
    const calculationHandler = () => {
        // Use the normalized fare: handles both distanceBreakdown shapes (number or
        // { value }), falls back to BookingDetails, and doubles two-way to match the
        // customer charge. Prevents the "amount: NaN" that the raw distance produced.
        const base = Number(bookingCost(bookingDetail))
        let total = Number.isNaN(base) ? 0 : base
        if (mealCost) {
            total = total + (+mealCost);
        }
        if (tollTax) {
            total = total + (+tollTax);
        }
        if (otherCost) {
            total = total + (+otherCost);
        }
        return total.toFixed(0)
    }
    const calculationSharingHandler = (item) => {
        let totalAccoupants = bookingDetail.carData.customerCapacity - bookingDetail.sharingAvailable;
        let remainingcost = item.amountBreakdown.remainingAmount;
        let total = remainingcost;
        let subtotal = 0
        if (mealCost) {
            subtotal = subtotal + (+mealCost);
        }
        if (tollTax) {
            subtotal = subtotal + (+tollTax);
        }
        if (otherCost) {
            subtotal = subtotal + (+otherCost);
        }
        total = (total+((subtotal/totalAccoupants)*item.passengerCount));
        return Math.round(total);
    }
    const completeTripHandler = async() => {
        try {
            let payload = {
                bookingDetailId : bookingDetail.BookingDetails[0].id,
                amount:calculationHandler(),
                transactionData : {
                    mealCost,
                    tollTax,
                    otherCost,
                    paymentRef,
                    paymentMode
                }
            }
            const response = await services.order.CREATE_PAYMENT(payload)
            let data = {
                bookingStatus: 'ended',
                bookingId: bookingDetail.id,
                bookingDetailId: bookingDetail.BookingDetails[0].id
            }
            const status = await services.order.UPDATE_STATUS(data);
            getBookingsHandler()
        } catch (error) {
            console.log(error)
        }
    }
    const completeSharingTripHandler = async() => {
        try {
            let totalAccoupants = bookingDetail.carData.customerCapacity - bookingDetail.sharingAvailable;
            bookingDetail.BookingDetails.map(async(item,index)=>{
                let payload = {
                    bookingDetailId : item.id,
                    amount:index == 0 ? calculationSharingHandler(item) - item.amountBreakdown.commissionPaid : calculationSharingHandler(item),
                    transactionData : {
                        mealCost : (mealCost/totalAccoupants)*item.passengerCount,
                        tollTax: (tollTax/totalAccoupants)*item.passengerCount,
                        otherCost : (otherCost/totalAccoupants)*item.passengerCount,
                        paymentRef,
                        paymentMode
                    }
                }
                const response = await services.order.CREATE_PAYMENT(payload)
                let data = {
                    bookingStatus: 'ended',
                    bookingId: bookingDetail.id,
                    bookingDetailId: item.id
                }
                const status = await services.order.UPDATE_STATUS(data);
            })
            getBookingsHandler()
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        if (!bookingDetail) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading booking…</h4></div></main>);
        }
        const bd = bookingDetail.BookingDetails?.[0] || {};
        const status = (bookingDetail.bookingStatus === 'cancelled' || bookingDetail.bookingStatus === 'failed') ? bookingDetail.bookingStatus : bd.bookingStatus;
        const stColor = status === 'ended' ? '#16a34a' : status === 'started' ? '#0ea5e9' : status === 'confirmed' ? '#0d6efd' : (status === 'cancelled' || status === 'failed' || status === 'rejected') ? '#ef4444' : '#f59e0b';
        // Use the vendor's actual car photo (same source as the booking list),
        // falling back to the master-car image only if it's missing.
        const photo = bookingDetail.VendorCar?.photos?.[0] || bookingDetail.Car?.photos?.[0];
        const ended = bd.bookingStatus === 'ended';
        const showCosts = bd.bookingStatus === 'started' || ended;
        const paid = isPayment ? isPayment / 100 : 0;
        const isSharing = bookingDetail?.sharingAvailable > 0 || bd?.amountBreakdown?.remainingAmount;
        // Once the vendor has accepted, expose the customer's contact details.
        const cust = bd?.customerData || {};
        const canContact = ['confirmed', 'accepted', 'started', 'ended'].includes(bd.bookingStatus) || bookingDetail.tripType === 'twoway';
        let collect = Number(bookingDetail ? calculationHandler() : NaN);
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader back="/mybookings" right={<span className="mlux-pill" style={{ background: `${stColor}1a`, color: stColor }}>{status}</span>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Manage trip</div>
                        <div className="nm" style={{ fontSize: 22 }}>Booking #{bookingDetail.id}</div>
                    </div>

                    <div className="mlux-card mlux-car" data-rise="1">
                        <div className="ph">
                            {photo ? <img src={constant.IMAGE_URL + photo} crossOrigin="anonymous" alt={`${bookingDetail.Car?.brand} ${bookingDetail.Car?.name}`} />
                                : <div style={{ height: '100%', display: 'grid', placeItems: 'center', color: '#94a3b8', fontSize: 42 }}><i className="far fa-car"></i></div>}
                        </div>
                        <div className="bd">
                            <div className="nm">{bookingDetail.Car?.brand} {bookingDetail.Car?.name}</div>
                            <div className="feats" style={{ marginBottom: 0 }}>
                                <span className="feat" style={{ padding: 0, background: 'transparent' }}><TripTypeBadge tripType={bookingDetail.tripType} /></span>
                                <span className="feat"><i className="far fa-road"></i> {bookingKm(bookingDetail) == null ? '—' : bookingKm(bookingDetail)} KM</span>
                            </div>
                        </div>
                    </div>

                    <div className="mlux-route mlux-card" style={{ padding: '16px 16px 16px 40px', marginTop: 12 }} data-rise="2">
                        <div className="pt from"><small>Pickup</small>{bd?.pickupLocation?.addressLine || '—'}</div>
                        <div className="pt to"><small>Drop</small>{bd?.dropLocation?.addressLine || '—'}</div>
                    </div>

                    {canContact && (
                        <>
                            <div className="mlux-sec-head"><h3>Customer</h3></div>
                            <div className="mlux-card mlux-contact" data-rise="2">
                                <div className="ci">
                                    <div className="av"><i className="far fa-user"></i></div>
                                    <div className="tx">
                                        <div className="nm">{cust.name || 'Customer'}</div>
                                        <div className="ph">{cust.phoneNumber || 'No number'}</div>
                                    </div>
                                </div>
                                {cust.phoneNumber && (
                                    <a className="mlux-callbtn" href={`tel:${cust.phoneNumber}`}>
                                        <i className="fas fa-phone"></i> Call
                                    </a>
                                )}
                            </div>
                        </>
                    )}

                    <div className="mlux-sec-head"><h3>Trip details</h3></div>
                    <div className="mlux-card" style={{ padding: '4px 16px' }} data-rise="2">
                        <div className="mlux-kv"><span className="k"><i className="far fa-calendar"></i> Journey date</span><span className="v">{moment(bookingDetail.tripStartDate).format('DD MMM YY')}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-flag-checkered"></i> End date</span><span className="v">{bookingDetail.tripEndDate ? moment(bookingDetail.tripEndDate).format('DD MMM YY') : '—'}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-user"></i> Passengers</span><span className="v">{bd?.passengerCount || '—'}</span></div>
                    </div>

                    {showCosts && (
                        <>
                            <div className="mlux-sec-head"><h3>Trip charges</h3></div>
                            <div className="mlux-card" style={{ padding: 16 }} data-rise="3">
                                <div className="mlux-note"><i className="far fa-circle-info"></i> Toll charges and driver batta are settled as per actuals.</div>
                                <label className="mlux-lbl">Payment mode</label>
                                <div className="mlux-field no-icon select"><select disabled={ended} value={paymentMode || ''} onChange={(e) => setPaymentMode(e.target.value)}><option value="">Choose payment mode</option><option value="cash">Cash</option><option value="online">Online</option></select></div>
                                {paymentMode === 'online' && <><label className="mlux-lbl">Payment reference</label><div className="mlux-field no-icon"><input type="text" disabled={ended} value={paymentRef || ''} placeholder="Payment ref" onChange={(e) => setPaymentRef(e.target.value)} /></div></>}
                            </div>
                        </>
                    )}

                    <div className="mlux-card mlux-fare" style={{ marginTop: 16 }} data-rise="3">
                        <div className="r"><span>Estimated fare</span><b>₹{bookingCost(bookingDetail) == null ? '—' : bookingCost(bookingDetail)}</b></div>
                        {paid > 0 && <div className="r"><span>Advance paid</span><b style={{ color: '#16a34a' }}>₹{paid.toFixed(0)}</b></div>}
                        <div className="r tot"><span className="lbl">Amount to collect</span><span className="amt">₹{Number.isNaN(collect) ? '—' : collect.toFixed(0)}</span></div>
                    </div>

                    {bd.bookingStatus === 'confirmed' && <button className="mlux-btn" style={{ marginTop: 16 }} onClick={() => changeStatusHandler()}><i className="far fa-circle-play"></i> Start trip</button>}
                    {bd.bookingStatus === 'started' && <button className="mlux-btn" style={{ marginTop: 16 }} onClick={() => { isSharing ? completeSharingTripHandler() : completeTripHandler(); }}><i className="far fa-flag-checkered"></i> End trip &amp; collect</button>}
                </main>
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">




            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        {bookingDetail && <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">Booking Detail #{bookingDetail.id}</h4>

                                            </div>
                                            <div class="row">

                                                <div class="col-md-12 mx-auto">
                                                    <div class="booking-form shadow-none">

                                                        <div class="col-md-12 col-lg-12 filter-item cat1 cat2">
                                                            <div class="row align-items-center ">
                                                                <a className="col-md-6 col-12"><div class="taxi-img">
                                                                    <img src={constant.IMAGE_URL + bookingDetail?.VendorCar.photos[0]} crossorigin="anonymous" width={'350px'} />
                                                                </div></a>
                                                                <div class="taxi-content col-md-6 col-12">
                                                                    <div class="taxi-head">
                                                                        <span> <b>Selected Car</b></span><h4>{bookingDetail.Car.brand} {bookingDetail.Car.name}</h4>

                                                                    </div>
                                                                    <div class="taxi-feature">
                                                                        <ul className="">
                                                                            <li> Estimated KM: <span> <b>{bookingKm(bookingDetail) == null ? '—' : bookingKm(bookingDetail)} KM</b></span></li>
                                                                            <li> Trip Type: <span> <TripTypeBadge tripType={bookingDetail.tripType} /></span></li>
                                                                            <li> Assigned Car Numbers: <span> <b>{bookingDetail.carData?.vendorCar?.rcNumber}</b></span></li>
                                                                            <li> Total Amount to be paid: <span> <b>Rs. {((bookingDetail.distanceBreakdown.distance / 1000) * (bookingDetail.isAcAvailable ? bookingDetail.VendorCar?.perKmCharge+1 : bookingDetail.VendorCar?.perKmCharge)).toFixed(0)}</b></span></li>
                                                                            {/* <li> Amount paid online: <span> <b className="bg-success text-white">Rs. {isPayment && isPayment / 100}</b></span></li> */}


                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        {bookingDetail?.vendorData && <><div class="user-profile-card-header mt-2">
                                                            <h4 class="user-profile-card-title">Partner Details</h4>

                                                        </div>
                                                            <div class="team-single-wrapper">
                                                                <div class="row align-items-center">
                                                                    <div class="col-lg-3">
                                                                        <div class="team-single-img">
                                                                            <img src={constant.IMAGE_URL + (bookingDetail?.vendorData?.VendorDetail?.businessLogo || bookingDetail?.Car?.photos[0])} crossorigin="anonymous" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-7">
                                                                        <div class="team-single-content">
                                                                            <div class="team-single-name">
                                                                                <h3>{bookingDetail?.vendorData?.firstName} {bookingDetail?.vendorData?.lastName}</h3>

                                                                            </div>

                                                                            <div class="team-single-info">
                                                                                <ul>
                                                                                    <li>
                                                                                        <span class="team-single-info-left"><i class="far fa-phone"></i>
                                                                                            Phone:</span>
                                                                                        <span class="team-single-info-right">{bookingDetail.vendorData.phoneNumber}</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <span class="team-single-info-left"><i class="far fa-envelope"></i>
                                                                                            Email:</span>
                                                                                        <span class="team-single-info-right">{bookingDetail.vendorData.email}</span>
                                                                                    </li>
                                                                                    {/* <li>
                                                                                        <span class="team-single-info-left"><i class="far fa-tools"></i>
                                                                                            Driving License:</span>
                                                                                        <span class="team-single-info-right">{bookingDetail.driverData.DriverDetail.drivingLicenceNumber}</span>
                                                                                    </li> */}
                                                                                </ul>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div></>}
                                                        <div class="user-profile-card-header mt-5">
                                                            <h4 class="user-profile-card-title">User Details</h4>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <div class="form-group">
                                                                    <label>Full Name</label>
                                                                    <input type="text" class="form-control" disabled={true} value={bookingDetail?.BookingDetails[0].customerData?.name} placeholder="Your Name" />
                                                                    <i class="far fa-user"></i>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <div class="form-group">
                                                                    <label>Phone Number</label>
                                                                    <input type="text" class="form-control" disabled={true} value={bookingDetail?.BookingDetails[0].customerData?.phoneNumber} placeholder="Your Phone" />
                                                                    <i class="far fa-phone"></i>
                                                                </div>
                                                                {bookingDetail?.BookingDetails[0].customerData?.phoneNumber && (
                                                                    <a href={`tel:${bookingDetail.BookingDetails[0].customerData.phoneNumber}`} class="theme-btn btn-sm mb-3"><i class="far fa-phone"></i> Call customer</a>
                                                                )}
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <div class="form-group">
                                                                    <label>Email</label>
                                                                    <input type="text" class="form-control" disabled={true} value={bookingDetail?.BookingDetails[0].customerData?.email} placeholder="Your Email" />
                                                                    <i class="far fa-envelope"></i>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <div class="form-group">
                                                                    <label>Pick Up Location</label>
                                                                    <input type="text" class="form-control" disabled={true} value={bookingDetail?.BookingDetails[0].pickupLocation.addressLine} placeholder="Type Location" />
                                                                    <i class="far fa-location-dot"></i>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <div class="form-group">
                                                                    <label>Drop Off Location</label>
                                                                    <input type="text" class="form-control" disabled={true} value={bookingDetail?.BookingDetails[0].dropLocation.addressLine} placeholder="Type Location" />
                                                                    <i class="far fa-location-dot"></i>
                                                                </div>
                                                            </div>


                                                            <div class="col-lg-6">
                                                                <div class="form-group">
                                                                    <label>Pick Up Date </label>
                                                                    <input type="text" class="form-control " disabled={true} value={moment(bookingDetail?.tripStartDate).format('DD/MM/YY')} placeholder="MM/DD/YY" />
                                                                    <i class="far fa-calendar-days"></i>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <div class="form-group">
                                                                    <label>Dropping date</label>
                                                                    <input type="text" class="form-control" disabled={true} value={moment(bookingDetail?.tripEndDate).format('DD/MM/YY')} placeholder="00:00 AM" />
                                                                    <i class="far fa-calendar-days"></i>
                                                                </div>
                                                            </div>


                                                            <div class="col-lg-12">
                                                                <div class="form-group">
                                                                    <label>Your Message</label>
                                                                    <textarea class="form-control" rows="5" disabled={true} value={bookingDetail.BookingDetails[0].customerNote}
                                                                        placeholder="Write Your Message"></textarea>
                                                                </div>
                                                            </div>
                                                            {(bookingDetail.BookingDetails[0].bookingStatus == 'started' || bookingDetail.BookingDetails[0].bookingStatus == 'ended') && <>
                                                                <div class="row align-items-center mt-5">
                                                                    <a className="col-md-6 col-12"><div class="taxi-img">
                                                                        <img src={constant.IMAGE_URL + bookingDetail?.vendorData.VendorDetail.documents} crossorigin="anonymous" width={'350px'} />
                                                                    </div></a>
                                                                    <div class="taxi-content col-md-6 col-12">
                                                                        <div class="taxi-head">
                                                                            <h4>Payment Break Down</h4>

                                                                        </div>
                                                                        <div class="taxi-feature">
                                                                            <ul className="">

                                                                                <li> Total Amount to be paid: <span> <b>Rs. {((bookingDetail.distanceBreakdown.distance / 1000) * (bookingDetail.isAcAvailable ? bookingDetail.VendorCar?.perKmCharge+1 : bookingDetail.VendorCar?.perKmCharge)).toFixed(0)}</b></span></li>
                                                                                {/* <li> Amount paid online: <span> <b className="bg-success text-white">Rs. {isPayment && isPayment / 100}</b></span></li> */}
                                                                                {/* <li> Amount remaining: <span> <b className="bg-warning text-white">Rs. {(((bookingDetail.distanceBreakdown.distance / 1000) * (bookingDetail.isAcAvailable ? bookingDetail.VendorCar?.perKmCharge+1 : bookingDetail.VendorCar?.perKmCharge)) - (isPayment / 100)).toFixed(0)}</b></span></li> */}
                                                                                <li className="text-muted"><i className="far fa-circle-info"></i> Toll charges and driver batta are settled as per actuals.</li>
                                                                                <hr />
                                                                                <li>Total Amount remaining: <span> <h4>Rs. {bookingDetail && calculationHandler()}</h4></span></li>
                                                                                <li>Payment Mode: <span>
                                                                                    <select className="border-0 text-right" disabled={bookingDetail.BookingDetails[0].bookingStatus == 'ended'} value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)}>
                                                                                        <option>Choose payment mode</option>
                                                                                        <option value={'cash'}>Cash</option>
                                                                                        <option value={'online'}>Online</option>
                                                                                    </select></span></li>
                                                                                {paymentMode == 'online' && <li>Payment reference <span> <input disabled={bookingDetail.BookingDetails[0].bookingStatus == 'ended'} type="text" className="border-0 text-right" onChange={(e) => setPaymentRef(e.target.value)} value={paymentRef} placeholder="Payment ref" /></span></li>}


                                                                            </ul>
                                                                        </div>

                                                                    </div>
                                                                    {bookingDetail.BookingReviews.length > 0 && <><div class="col-lg-6">
                                                                    <label>Share your Rating</label> <br/>
                                                                        <Rating
                                                                            initialValue={bookingDetail.BookingReviews[0].rating}
                                                                        />
                                                                    </div>


                                                                    <div class="col-lg-12">
                                                                        <div class="form-group">
                                                                            <label>Share your review</label>
                                                                            <textarea class="form-control" rows="5" value={bookingDetail.BookingReviews[0].comment} 
                                                                                placeholder="Write Your Message"></textarea>
                                                                        </div>
                                                                    </div></>}
                                                                </div>
                                                            </>}
                                                          {(bookingDetail?.sharingAvailable > 0 || bookingDetail?.BookingDetails[0]?.amountBreakdown?.remainingAmount) && <div class="table-responsive">
                                            <table class="table text-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th className="">Customer Name</th>
                                                        <th>Passengers</th>
                                                        <th>Total</th>
                                                        <th>Paid</th>
                                                        <th>Remaining</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookingDetail?.BookingDetails?.map((item, index)=>{return(<tr key={item.id}>
                                                        <td>
                                                            <div class="table-list-info">
                                                                <a href="#">
                                                                    {/* <img src="/assets/img/taxi/01.png" alt/> */}
                                                                    <div class="table-list-content">
                                                                        <h6>{item.customerData.name}</h6>
                                                                        <span>{item.customerData.phoneNumber}</span>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {item.passengerCount}
                                                        </td>
                                                        <td>
                                                          Rs. {calculationSharingHandler(item)}
                                                        </td>
                                                        <td>Rs. {item.amountBreakdown.commissionPaid}</td>
                                                        
                                                        <td>
                                                           Rs. {index == 0 ? calculationSharingHandler(item) - item.amountBreakdown.commissionPaid : calculationSharingHandler(item)}
                                                        </td>
                                                    </tr>)})}
                                                   
                                                </tbody>
                                            </table>
                                        </div>}
                                                            <div class="col-lg-9 mx-auto d-flex mt-4">

                                                                {bookingDetail.BookingDetails[0].bookingStatus == 'confirmed' && <button onClick={() => changeStatusHandler()} class="theme-btn mx-4" >Start Trip<i
                                                                    class="fas fa-arrow-right"></i></button>}
                                                                    {bookingDetail.BookingDetails[0].bookingStatus == 'started' && <button onClick={() => {(bookingDetail?.sharingAvailable > 0 || bookingDetail?.BookingDetails[0]?.amountBreakdown?.remainingAmount) ? completeSharingTripHandler() : completeTripHandler()}} class="theme-btn mx-4" >End Trip<i
                                                                    class="fas fa-arrow-right"></i></button>}
                                                            </div>



                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        {/* <Footer /> */}
    </>
    )
}
export default OrderDetails